const ITEMS = [
  "Master Trading",
  "Strategy Trading",
  "Vault Trading",
  "Vault Yield",
  "Non-Custodial",
  "Custodial",
  "Audited & Verified",
  "Risk Transparency",
];

function Row({ ariaHidden = false }) {
  return (
    <div className="flex items-center shrink-0" aria-hidden={ariaHidden}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center shrink-0">
          <span className="px-8 sm:px-12 font-display text-xl sm:text-3xl font-semibold tracking-wide text-zinc-600 whitespace-nowrap">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold-400/60 shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="marquee-hover relative overflow-hidden border-y border-gold-400/12 py-7 bg-ink-800/40"
    >
      <div className="marquee-row animate-marquee">
        <Row />
        <Row ariaHidden />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink-900 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink-900 to-transparent" />
    </section>
  );
}